import api from "@/apisTuk";
import geo from "@/geo";

// synchronous: store.commit()
export default {
  initialiseStore(state) {
    if (localStorage.getItem("store")) {
      // Check if the ID exists
      this.replaceState(
        // Replace the state object with the stored item
        Object.assign(state, JSON.parse(localStorage.getItem("store")))
      );
      state.initialisedAt = new Date();
      // Vue.i18n.add('en', languages.en);
      // Vue.i18n.add('th', languages.th);
      // Vue.i18n.set('th'); // set the start locale to use
    } else {
      console.log("initaliseStore NO STORE in localStorage");
    }
    // previously these might be nulls, so need to set to empty array
    if (!state.roles) state.roles = [];
    if (!state.workflows) state.workflows = [];
  },
  logAction(state, action) {
    state.actions.push(action);
  },
  updateScreenSize(state) {
    state.height = window.innerHeight;
    state.width = window.innerWidth;
  },
  setRideCount(state, cnt) {
    state.rideCount = cnt;
  },
  setBasket(state, basket) {
    state.basket = basket;
  },
  setCommerceOrder(state, order) {
    state.commerceOrder = order;
  },
  setBatchOrders(state, orders) {
    state.batchOrders = orders;
  },
  startBatch(state, time) {
    state.batchStartedAt = time;
  },
  setBatchVehicleCount(state, n) {
    state.batchVehicleCount = n;
  },
  setBatchVehicleCompleted(state, completed) {
    if (!completed) state.batchVehiclesCompleted = []; // reset
    state.batchVehiclesCompleted.push(completed); // add to completed arr
  },
  setNotificationToken(state, token) {
    state.notificationToken = token;
    if (state.user) state.user.notification_token = token;
  },
  rejectAllTransactions(state, ids) {
    state.rejectedTransactions = state.rejectedTransactions.concat(ids);
  },
  toggleDriverSettingHideNewJobs(state) {
    state.driverSettingHideNewJobs = !state.driverSettingHideNewJobs;
  },
  rejectTransaction(state, id) {
    state.rejectedTransactions.push(id);
  },
  undoRejectedTransactions(state) {
    state.rejectedTransactions = [];
  },
  networkError(state, obj) {
    if (state.networkErrors.length >= 15) {
      state.networkErrors.shift(); // keep only 15
    }
    state.networkErrors.push(obj);
  },
  endTransaction(state, id) {
    state.endedTransactions.push(id);
  },
  cacheBusiness(state, obj) {
    // if (state.businesses.length >= 5) state.businesses = [];
    if (state.businesses.length >= 5) state.businesses.shift(); // keep only n
    obj.fetched_at = new Date();
    state.businesses.push(obj);
  },
  selectBusiness(state, id) {
    if (!state.businesses) {
      state.selectedBusiness = null;
      return;
    }
    state.selectedBusiness = state.businesses.find(b => b.id === id);
    if (!state.selectedBusiness) return;
    state.selectedBusiness = JSON.parse(JSON.stringify(state.selectedBusiness)); // force update it
    // if business is not found should go to DB
  },
  updateSelectedTransport(state, workflow) {
    state.selectedTransport = workflow;
  },
  selectTransport(state, workflow) {
    // the more generic case, could be private or local tuk
    state.selectedTransport = workflow;
    if (!workflow) {
      state.selectedTransportType = "";
      return;
    }
    if (workflow.workflow_type_name === "Private Tuk Tuk") {
      state.selectedTukTuk = workflow; // could select transport of tuktuk
      state.selectedTransportType = "privatetuk";
    }
    // } else state.selectedTransportType = "localtuk"
    if (workflow.workflow_type_name === "Sii Lor") {
      state.selectedTransportType = "localtuk";
    }
    if (workflow.workflow_type_name === "Songthaew") {
      state.selectedTransportType = "songthaew";
    }
  },
  selectTukTuk(state, workflow) {
    // your last selected private tuk
    state.selectedTukTuk = workflow;
    state.selectedTransport = workflow; // if you just selected a tuktuk then also set as transport
    if (workflow.workflow_type_name === "Private Tuk Tuk") {
      state.selectedTransportType = "privatetuk";
    } else state.selectedTransportType = "localtuk";
  },
  clearTukTuk(state) {
    state.selectedTukTuk = null;
    state.selectedTransport = null;
  },
  setPhotosOnBusiness(state, photos) {
    // selectedBusiness should not be null
    if (!state.selectedBusiness) return;
    state.selectedBusiness.menu_photos = photos;
    // force update...
    state.selectedBusiness = JSON.parse(JSON.stringify(state.selectedBusiness));
  },
  setWorkflowsOnBusiness(state, workflows) {
    // selectedBusiness should not be null
    if (!state.selectedBusiness) return;
    state.selectedBusiness.workflows = workflows;
    // force update...
    state.selectedBusiness = JSON.parse(JSON.stringify(state.selectedBusiness));
  },
  setWorkflows(state, workflows) {
    // previously called setWorkflowsByType
    state.workflows = workflows;
    if (!workflows) state.workflows = [];
  },
  setLogisticsFleet(state, fleet) {
    state.logisticsFleet = fleet;
  },
  setOngoingLogisticsAgentTransactions(state, transactions) {
    state.ongoingLogisticsAgentTransactions = transactions;
    state.logisticsAgentTransactionsUpdatedAt = new Date();
  },
  setPastLogisticsAgentTransactions(state, transactions) {
    state.pastLogisticsAgentTransactions = transactions;
  },
  clearCommerceAgentTransactions(state) {
    state.ongoingCommerceAgentTransactions = [];
    state.pastCommerceAgentTransactions = [];
  },
  setOngoingCommerceAgentTransactions(state, transactions) {
    state.ongoingCommerceAgentTransactions = transactions;
    state.commerceAgentTransactionsUpdatedAt = new Date();
  },
  setPastCommerceAgentTransactions(state, transactions) {
    state.pastCommerceAgentTransactions = transactions;
  },
  setOngoingDispatcherTransactions(state, transactions) {
    state.ongoingDispatcherTransactions = transactions || [];
  },
  setTransactionsForWorker(state, transactions) {
    state.workerTransactions = transactions;
  },
  setOngoingTransactionsForWorker(state, transactions) {
    state.ongoingWorkerTransactions = transactions;
  },
  setTransactionsForCustomer(state, transactions) {
    state.customerTransactions = transactions;
  },
  setRecentTransactionsForCustomer(state, transactions) {
    state.recentCustomerTransactions = transactions;
  },
  setOngoingTransactionsForCustomer(state, transactions) {
    state.ongoingCustomerTransactions = transactions;
  },
  setDriverStats(state, driverStats) {
    state.driverStats = driverStats;
  },
  setDriverCancelledAt(state) {
    state.driverCancelledAt = new Date();
  },
  setFakeGPS(state, fake) {
    state.fakeGPS = fake;
  },
  setFakeGPSLocation(state, obj) {
    state.fakeGPSLocation = obj;
  },
  visitedShop(state, shop) {
    var exists = state.shopHistory.find(s => s.key === shop.key);
    if (exists) {
      exists.pic = shop.pic;
      exists.count += 1;
      exists.updated_at = new Date();
    } else {
      shop.count = 1; // start counter
      shop.updated_at = new Date();
      state.shopHistory.push(shop);
    }
  },
  removeVisitedShop(state, shopID) {
    // remove this shop from state.shopHistory
    state.shopHistory = state.shopHistory.filter(s => s.key !== shopID);
  },
  favorite(state, businessID) {
    var index = state.favorites.indexOf(businessID);
    if (index > -1) {
      state.favorites.splice(index, 1);
    } else {
      // if (state.favorites.includes(businessID)) return;
      state.favorites.push(businessID);
    }
  },
  toggleSuperUser(state, trueFalse) {
    // optional bool param or just toggle
    if (state.secret < 3) return; // do nothing unless secret activated
    if (trueFalse != null) state.superUser = trueFalse;
    else state.superUser = !state.superUser;
  },
  logout(state) {
    // should set logged out in database also
    state.lineUser = null;
    state.userSource = null;
    state.user = null;
    state.magicLogin = null; // or commit clearMagicLogin
    state.roles = [];
    state.workerTransactions = null;
    state.ongoingWorkerTransactions = null;
    state.customerTransactions = null;
    state.ongoingCustomerTransactions = null;
    state.recentCustomerTransactions = null;
    state.addresses = null; //{};
    state.agentMode = false;
    state.messages = null;
    // state.isPollingLocation: false
    // clear transactions, addresses etc
    // anything related to logged out user
  },
  setTransportType(state, transportType) {
    state.selectedTransportType = transportType;
  },
  setDevice(state, data) {
    state.device = data;
  },
  setUUID(state, data) {
    if (!state.uuid) state.uuid = data;
    api.updateTUKAuthWithUUID(state.uuid.uuid);
  },
  setCameraState(state, hasCamera) {
    if (state.device) state.device.hasCamera = hasCamera;
  },
  setMapState(state) {
    // depends on state.isWorking and state.customerTransactions
    var mapState = ""; // default mapState is empty string, not driver or passenger
    if (state.isWorking) mapState = "driver";
    if (!state.isWorking && state.customerTransactions) {
      var activeTransactions = state.customerTransactions.filter(
        t => !state.endedTransactions.includes(t.id)
      );
      if (activeTransactions.length > 0) mapState = "passenger";
    }
    state.mapState = mapState; // '', 'driver', 'passenger'
  },
  setLineUser(state, data) {
    state.lineUser = data;
  },
  setUser(state, data) {
    state.user = data.user;
    state.userSource = data.user_source;
    state.roles = data.roles;
    if (!state.roles) state.roles = [];
    if (data.user.language) state.language = data.user.language;
  },
  updateUser(state, user) {
    state.user = user;
  },
  setProfilePic(state, profilePic) {
    state.user.profile_pic_url = profilePic;
  },
  setRealName(state, name) {
    state.user.name = name;
  },
  setPhoneNumber(state, number) {
    state.user.phone_number = number;
  },
  // need to fix this, now use array not obj
  setUserAddress(state, data) {
    state.addresses[data.address_type] = data;
    state.addresses = JSON.parse(JSON.stringify(state.addresses));
  },
  addUserAddress(state, data) {
    state.addresses.push(data);
  },
  setUserAddresses(state, data) {
    state.addresses = data;
  },
  setVersion(state, version) {
    state.version = version;
  },
  setInternetState(state, hasInternet) {
    state.hasInternet = hasInternet;
  },
  forceRedirect(state, redirect) {
    state.forceRedirect = redirect;
  },
  magicLogin(state, data) {
    state.magicLogin = data;
  },
  loginMethod(state, method) {
    state.loginMethod = method;
  },
  clearMagicLogin(state, caller) {
    console.log("clearMagicLogin caller", caller);
    state.magicLogin = null;
  },
  addPolyline(state, data) {
    state.polylines.unshift(data); // push to the front of the array
    state.polylines = state.polylines.slice(0, 20); // cap array length at 20
  },
  setPrivateTransport(state, workflow) {
    state.yourPrivateTransport = workflow;
  },
  setForYouEat(state, data) {
    if (!data) return;
    state.forYouEat = data;
    hydrateForYouEat(state);
  },
  setNewShops(state, data) {
    if (!data) return;
    state.newShops = data;
  },
  setEatLists(state, data) {
    if (!data) return;
    state.eatLists = data;
  },
  setEateries(state, data) {
    if (!data) return; // state.eateries = []
    state.eateries = data;
    if (state.userState) {
      state.eateries.forEach(e => {
        var meters = geo.distanceToUserInMeters(state.userState, e); // straight line dist
        e.distance = Math.round(meters * 1.3); // approx driving dist
        e.prettyDistance = geo.prettyDistance(e.distance, 99); // pretty like 2.3km
        if (e.distance > 99 * 1000) e.prettyDistance = ""; // blank over max
      });
    }
    hydrateForYouEat(state);
  },
  setMarts(state, data) {
    if (!data) {
      state.marts = [];
      return;
    }
    state.marts = data;
    // probably unnecessary to do this since I just need the closest which I can sort in DB query
    if (state.userState) {
      state.marts.forEach(e => {
        e.distance = Math.round(
          geo.distanceToUserInMeters(state.userState, e) * 1.3
        );
        e.prettyDistance = geo.prettyDistance(e.distance, 99);
        if (e.distance > 99 * 1000) e.prettyDistance = ""; // blank over max
      });
      state.marts.sort((a, b) => {
        return a.distance - b.distance;
      });
    }
  },
  setTransport(state, data) {
    // if (!data) return //
    if (!data) {
      state.transport = [];
      return;
    }
    state.transport = data;
    if (state.userState) {
      state.transport.forEach(t => {
        t.distance = Math.round(
          geo.distance(state.userState, t.business) * 1.3
        );
        t.prettyDistance = geo.prettyDistance(t.distance, 99);
        if (t.distance > 99 * 1000) t.prettyDistance = ""; // blank over max
      });
      state.transport.sort((a, b) => {
        return a.distance - b.distance;
      });
    }
  },
  setUserStops(state, data) {
    if (!data) {
      //return // or clear out stops []
      state.userStops = [];
      return;
    }
    state.userStops = data;
    if (!state.userState) return;
    state.userStops.forEach(s => {
      s.distance = Math.round(geo.distance(state.userState, s) * 1.3);
      s.prettyDistance = geo.prettyDistance(s.distance, 99);
      if (s.distance > 99 * 1000) s.prettyDistance = ""; // blank over max
    });
    // state.transport.sort((a, b) => {
    //     return a.distance - b.distance;
    // });
  },
  // deprecated businesses stuff
  setBusinesses(state, data) {
    state.businesses = data;
    if (!state.businesses) state.businesses = []; // empty array, not null
  },
  clearBusinesses(state) {
    state.businesses = []; // clear businesses for Jig
  },
  addSuperRole(state, role) {
    if (!role) return (state.superRoles = []); // clear...
    var exists = state.superRoles.find(s => s.workflow_id === role.workflow_id);
    if (exists) {
      exists = role; // just update existing
    } else {
      if (state.superRoles.length >= 3) state.superRoles.shift();
      state.superRoles.push(role);
      state.superRoles = JSON.parse(JSON.stringify(state.superRoles)); // force
    }
  },
  updateSuperRole(state, data) {
    var workflow = data.workflows[0]; // could be more than 1?
    var role = state.superRoles.find(s => s.workflow_id === workflow.id);
    if (!role) return;
    role.business = data.business;
    role.workflow = workflow;
    state.superRoles = JSON.parse(JSON.stringify(state.superRoles)); // force
  },
  activateCommerceAgentRole(state, idx) {
    var roles = state.roles.filter(r => r.role_name === "Commerce Agent");
    roles.forEach(r => (r.active = false));
    roles[idx].active = true;
    // roles.find(r => r.id === id).active = true;
    state.roles = JSON.parse(JSON.stringify(state.roles)); // force
  },
  activateCommerceAgentRoleByID(state, ID) {
    var roles = state.roles.filter(r => r.role_name === "Commerce Agent");
    roles.forEach(r => (r.active = false));
    roles.find(r => r.id === ID).active = true;
    state.roles = JSON.parse(JSON.stringify(state.roles)); // force
  },
  setActiveCommerceAgentRole(state, ID) {
    state.activeCommerceAgentRoleID = ID;
  },
  activateFavoriteCommerceAgentRole(state) {
    var favorite = roles.find(r => r.data.start_url);
    if (!favorite) return;
    var roles = state.roles.filter(r => r.role_name === "Commerce Agent");
    roles.forEach(r => (r.active = false));
    favorite.active = true;
    state.roles = JSON.parse(JSON.stringify(state.roles)); // force
  },
  setRoles(state, data) {
    state.roles = data; // set roles data
    if (!state.roles) {
      // also set super user
      state.roles = [];
      state.superUser = false;
      state.isWorking = false;
      return;
    }
    var superUser = state.roles.find(role => role.role_type === "superuser");
    if (superUser) state.superUser = true;
    else state.superUser = false;
    var working = state.roles.find(r => r.state === "working");
    if (working) {
      state.isWorking = true; // set working state if working
      state.workingState = working.role_name;
      state.workingRole = working;
    } else {
      state.isWorking = false; // set not working if no roles in working state
      state.workingState = "";
      state.workingRole = null;
    }
  },
  setNearbySiilors(state, siilorWorkflows) {
    var ids = siilorWorkflows.map(w => w.id);
    state.nearbySiilors = ids.join();
  },
  setNearbySongthaews(state, songthaewWorkflows) {
    var ids = songthaewWorkflows.map(w => w.id);
    state.nearbySongthaews = ids.join();
  },
  setNearbyMotocys(state, motocyWorkflows) {
    var ids = motocyWorkflows.map(w => w.id);
    state.nearbyMotocys = ids.join();
  },
  setGooglePlace(state, payload) {
    state.googlePlace = payload.place;
    state.googleCoords = payload.coords;
  },
  setStopCoords(state, coords) {
    state.stopCoords = coords;
  },
  notGooglePlace(state) {
    // nil out googlePlace if using coords drag
    state.googlePlace = null;
  },
  setPollingLocationBool(state, isPollingLocation) {
    state.isPollingLocation = isPollingLocation;
  },
  setLanguage(state, languageCode) {
    state.language = languageCode;
  },
  setWorkingState(state, role) {
    // currently only used for driver working state
    state.rejectedTransactions = []; // reset rejectedTransactions
    if (role) {
      state.workingRole = role;
      state.workingState = role.role_name; // Driver or Dispatcher
      state.isWorking = true;
    } else {
      state.workingRole = null;
      state.workingState = "";
      state.isWorking = false;
    }
  },
  setWelcomeTo(state, stateBool) {
    state.welcomeTo = stateBool; // true or false
  },
  setUserState(state, location) {
    if (location.lat && location.lon) {
      // compute distance between old and new locations
      var dist = -1; // init dist to -1 so we know if it's first time to re-pull workflows etc
      if (state.userState)
        dist = geo.distanceToUserInMeters(state.userState, location);
      // now set updated userState
      state.userState = location;
      state.userState.updated_at = new Date();
      state.userState.distance = dist;
    } else {
      console.warn("setUserState invalid location", location);
    }
  },
  setSuperpower(state, superpower) {
    state.superpower = superpower;
  },
  setSystemSpeed(state, speed) {
    state.systemSpeed = speed; // speed of api call in ms
  },
  setCPUBenchmark(state, benchmark) {
    state.cpuBenchmark = benchmark;
  },
  clearLocation(state) {
    console.log("clearLocation");
    state.userState = null;
  },
  setTimestamp(state, name) {
    state.timestamps[name] = new Date();
  },
  clearTimestamp(state, name) {
    state.timestamps[name] = null;
  },
  stashPWAPrompt(state, e) {
    state.pwaPrompt = e; // catch and stash android pwa prompt
  },
  incrementSecret(state) {
    // used for secretly turning on/off superuser powers
    state.secret += 1;
    if (state.secret >= 6) state.secret = 0;
  },
  setCompassHeading(state, compassHeading) {
    state.compassHeading = compassHeading;
  },
  log() {
    console.log();
  },
  selectDriver(state, id) {
    state.selectedDriver = id;
    // if (!id) state.isPromoReferral = false // if clearing ID, set false isPromoReferral
  },
  setReferralCode(state, code) {
    state.referralCode = code;
  },
  setRegion(state, region) {
    state.region = region;
  },
  setAgentMode(state, mode) {
    state.agentMode = mode; // t / f
  },
  newNotification(state, data) {
    if (data) data.created_at = new Date().toLocaleString();
    state.notification = data;
  },
  setIPAddress(state, data) {
    state.ipAddress = data;
    state.ipAddress.createdAt = new Date();
  },
  setStorage(state, data) {
    state.storage = data;
  },
  setStoragePersisted(state, bool) {
    state.storagePersisted = bool;
  },
  setShopsOrServices(state, type) {
    state.shopsOrServices = type; // "shops" or "services"
  },
  resetRouteHistory(state) {
    state.routeHistory = [];
  },
  updateRouteHistory(state, route) {
    if (state.routeHistory[state.routeHistory.length - 1] === route) return; // skip duplicate
    state.routeHistory.push(route);
  },
  setMessages(state, messages) {
    state.messages = messages;
  },
  setQRScannerSound(state, idx) {
    state.qrScannerSound = idx;
  },
  toggleTheme(state, theme) {
    if (theme) {
      state.theme = theme;
    } else {
      if (state.theme === "light") state.theme = "dark";
      else state.theme = "light";
    }
  }
};

function hydrateForYouEat(state) {
  hydrateForYouScore(state.eateries, state.forYouEat);
}

function hydrateForYouScore(arr, kv) {
  // first set foryou score to zero for all businesses in array
  arr.forEach(b => (b.foryou = 0));
  // then set the actual value if exists in kv array
  kv.forEach(o => {
    // console.log("hydrateForYouScore", o.key, o.score)
    for (var i = 0; i < arr.length; i++) {
      if (arr[i].id === o.key) {
        arr[i].foryou = o.score;
        break;
      }
    }
  });
}
